var map = {
	"./balanced.jpg": "73c3",
	"./cardiovascular.jpg": "5efd",
	"./castalis_slim_balanced.jpg": "01e4",
	"./castalis_slim_gluten_free.jpg": "dac5",
	"./castalis_slim_vegetarian.jpg": "94ac",
	"./diabete.jpg": "6048",
	"./easy_digest.jpg": "eb3a",
	"./gluten_free.jpg": "3eab",
	"./hypertension.jpg": "e4d7",
	"./normolipidic.jpg": "2aca",
	"./slim.jpg": "901e",
	"./vegan.jpg": "bc9e",
	"./vegetarian.jpg": "6c59"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ed53";